@if (viewerConfiguration) {
  <div id="viewerControls" class="viewer-controls-wrapper">
    <div class="w-100">
      @if (viewerConfiguration.includeNavigation || viewerConfiguration.includeAudio) {
        <div id="assetNavigation" class="h-auto assetNavigation w-100" [class.assetNavigationCompressed]="zoomLevel > 100">
          @if (viewerConfiguration.includeNavigation) {
            <zbp-viewer-navigation-toggle [navToggle]="asset?.navigationToggles" [pageInfo]="asset?.pageInfo"></zbp-viewer-navigation-toggle>
          }
          @if (viewerConfiguration.includeAudio) {
            <zbp-viewer-audio-player [assetIds]="asset?.relatedAudio" [assetList]="viewerAssets"></zbp-viewer-audio-player>
          }
        </div>
      }
    </div>
    <div class="w-100">
      @if (viewerConfiguration.includeZoom || viewerConfiguration.includeDigitalInk || viewerConfiguration.includePrint) {
        <div class="zoomPrintAndInk">
          <div class="zoomControl">
            @if (viewerConfiguration.includeZoom) {
              <zbp-viewer-zoom
                    [enabled]="viewerConfiguration.enableZoom"
                    (activeZoomTool)="setActiveZoomTool($event)"
                    (zoomPercent)="setZoomPercent($event)"
                    [zoomMin]="viewerConfiguration.zoomMin"
                    [zoomMax]="viewerConfiguration.zoomMax"
                    [zoomIncrement]="viewerConfiguration.zoomIncrement"
              ></zbp-viewer-zoom>
            } @else {
              <zbp-viewer-print (triggerPrint)="printImage()"></zbp-viewer-print>
            }
          </div>
          <div class="inkControl">
            @if (viewerConfiguration.includeDigitalInk) {
              <zbp-viewer-draw
                [enabled]=viewerConfiguration.enableDigitalInk
                (activeDrawingTool)="setActiveDrawingTool($event)">
              </zbp-viewer-draw>
            }
          </div>
        </div>
      }
    </div>

    <!-- Notes Section - Start 1/2 width and expands 100% when opened -->
    @if (viewerConfiguration.includeAdditionalInfo) {
     <div class="w-100">
        <zbp-viewer-additional-info
          [asset]="asset"
        />
     </div>

    }
  </div>
}
